/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'DigitalCast';

const classes = {
  breadcrumbs: `${PREFIX}-breadcrumbs`,
  periodSelector: `${PREFIX}-periodSelector`,
  banner: `${PREFIX}-banner`,
};

const Root = styled(Box)(({theme}) => ({
  [`& .${classes.breadcrumbs}`]: {
    margin: theme.spacing(4, 0, 8, 0),
  },
  [`& .${classes.periodSelector}`]: {
    margin: theme.spacing(4, 0),
  },
  [`& .${classes.banner}`]: {
    margin: theme.spacing(0, 0, 8, 0),
  },
}));

export {Root as DigitalCastRoot, classes as digitalCastClasses};
